import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { AsyncSandboxEchoPage } from '@jira/spa-apps__sandbox-relay/src/ui/AsyncSandboxEchoPage.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { sandboxEchoPageRelayResource } from '@jira/router-resources__sandbox/src/sandboxEchoPageRelayResource.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { sandboxRelayEchoPageUsingRLLRoute } from '@jira/router-routes__sandbox-routes/src/sandboxRelayEchoPageUsingRLLRoute.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { Skeleton } from './ui/index.tsx';

export const sandboxRelayEchoPageUsingRLLRouteEntry: Route = createEntry(
	sandboxRelayEchoPageUsingRLLRoute,
	() => ({
		group: 'sandbox',
		layout: globalLayout,
		skeleton: Skeleton,
		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: AsyncSandboxEchoPage,
		lazyForPaint: [AsyncSandboxEchoPage],
		resources: [...jiraSpaResources(), sandboxEchoPageRelayResource],
		ufoName: 'sandbox-relay-echo',

		bifrost: {
			// WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
			// manifestName: 'jira-spa-sandboxdemo.json',
			bifrostGroup: 'not-deployed',
		},
	}),
);
